import React, { useEffect, useState } from "react";
import AOS from "aos";
import { FaReact, FaNodeJs, FaPhp, FaBriefcase, FaCheckCircle } from "react-icons/fa";
import { SiMongodb } from "react-icons/si";
import { MdLocationOn } from "react-icons/md";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import profilePic from "../assets/img/profile.png";
import "aos/dist/aos.css";
import colorSharp2 from '../assets/img/color-sharp2.png';

export default function AboutPage() {
  const [time, setTime] = useState(new Date().toLocaleTimeString());

  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
    const interval = setInterval(() => {
      setTime(new Date().toLocaleTimeString());
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  const particlesInit = async (main) => {
    await loadFull(main);
  };

  return (
    <section className="
    text-light py-5" id="aboutme" >
      {/* Floating particles */}
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={{
          background: { color: "transparent" },
          particles: {
            number: { value: 40 },
            size: { value: 3 },
            move: { speed: 1 },
            links: { enable: true, color: "#6f42c1" },
          },
        }}
        className="position-absolute w-100 h-100"
        style={{ zIndex: 0 }}
      />

      <div className="container position-relative" style={{ zIndex: 1 }}>
        {/* Profile + Intro */}
        <div className="row align-items-center mb-5">
          <div className="col-md-4 text-center" data-aos="fade-right">
            <div className="position-relative d-inline-block">
              {/* Gradient background blob */}
              <div
                className="position-absolute top-50 start-50 translate-middle rounded-circle"
                style={{
                  width: "280px",
                  height: "280px",
                  background:
                    "radial-gradient(circle at 30% 30%, #0d6efd, #6f42c1)",
                  filter: "blur(80px)",
                  zIndex: 0,
                }}
              ></div>
              <img
                src={profilePic}
                alt="Tariq"
                className="rounded-circle shadow-lg img-fluid border border-3 border-primary position-relative"
                style={{ width: "220px", height: "220px", zIndex: 1 }}
              />
            </div>
          </div>

          <div className="col-md-8" data-aos="fade-left">
            <h2 className="fw-bold display-5">Tariq Mehmood</h2>
           
            <p className="fst-italic text-light">
              "Clean Code. Smart Design. Real Impact."
            </p><br/>
            <p className="lead ">
              I’m a <span className="fw-bold text-light highlight">Full-Stack Web Developer</span> 
              with 3+ years of experience crafting applications where{" "}
              <strong>design meets performance</strong>.
            </p>
            <br/>
            <p>
              From <span className="text-primary">frontend interfaces</span> that feel alive, 
              to <span className="text-primary">backend systems</span> that scale with confidence — 
              I deliver digital products that solve problems and inspire users.
            </p>

            {/* Quick Facts */}
            <div className="row text-center mt-4">
              <div className="col-4" data-aos="zoom-in">
                <div className="p-3 bg-secondary bg-opacity-25 rounded shadow-sm hover-glow">
                  <FaBriefcase aria-label="Experience" className="fs-3 text-warning mb-2" />
                  <h6 className="fw-bold mb-0">3+ Years</h6>
                  <small className="text-mute">Experience</small>
                </div>
              </div>
              <div className="col-4" data-aos="zoom-in" data-aos-delay="100">
                <div className="p-3 bg-secondary bg-opacity-25 rounded shadow-sm hover-glow">
                  <MdLocationOn aria-label="Location" className="fs-3 text-danger mb-2" />
                  <h6 className="fw-bold mb-0">Pakistan</h6>
                  <small>Local Time: {time}</small>
                </div>
              </div>
              <div className="col-4" data-aos="zoom-in" data-aos-delay="200">
                <div className="p-3 bg-secondary bg-opacity-25 rounded shadow-sm hover-glow">
                  <FaCheckCircle aria-label="Availability" className="fs-3 text-success mb-2" />
                  <h6 className="fw-bold mb-0">Available</h6>
                  <small >For Remote Work</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Why Me Section */}
        <div className="row my-5" data-aos="fade-up">
          <h3 className="fw-bold text-center mb-4">Why Me?</h3>
          <div className="col-md-4 text-center p-3">
            <div className="bg-secondary bg-opacity-25 rounded p-4 hover-glow">
              <h5 className="fw-bold">Team Player</h5>
              <p className="">I thrive in collaboration, valuing teamwork to achieve shared goals.</p>
            </div>
          </div>
          <div className="col-md-4 text-center p-3">
            <div className="bg-secondary bg-opacity-25 rounded p-4 hover-glow">
              <h5 className="fw-bold">Problem Solver</h5>
              <p className="">I see challenges as opportunities to innovate and create lasting solutions.</p>
            </div>
          </div>
          <div className="col-md-4 text-center p-3">
            <div className="bg-secondary bg-opacity-25 rounded p-4 hover-glow">
              <h5 className="fw-bold">Quick Learner</h5>
              <p className="">I adapt to new technologies fast, keeping projects future-ready.</p>
            </div>
          </div>
        </div>

        {/* Skills Cards */}
        <div className="row text-center g-4">
          <h3 className="mb-4 fw-bold" data-aos="fade-up">My Core Skills</h3>

          <div className="col-md-3 col-6" data-aos="zoom-in">
            <div className="card shadow-lg border-0 h-100 p-4 skill-card react-card">
              <FaReact size={50} className="text-info mx-auto mb-3" />
              <h5>React.js</h5>
              <p>Creating UIs that feel natural, fast, and alive.</p>
            </div>
          </div>

          <div className="col-md-3 col-6" data-aos="zoom-in" data-aos-delay="100">
            <div className="card shadow-lg border-0 h-100 p-4 skill-card node-card">
              <FaNodeJs size={50} className="text-success mx-auto mb-3" />
              <h5>Node.js</h5>
              <p>Backends engineered to scale with confidence.</p>
            </div>
          </div>

          <div className="col-md-3 col-6" data-aos="zoom-in" data-aos-delay="200">
            <div className="card shadow-lg border-0 h-100 p-4 skill-card mongo-card">
              <SiMongodb size={50} className="text-success mx-auto mb-3" />
              <h5>MongoDB</h5>
              <p>Databases that evolve as your product grows.</p>
            </div>
          </div>

          <div className="col-md-3 col-6" data-aos="zoom-in" data-aos-delay="300">
            <div className="card shadow-lg border-0 h-100 p-4 skill-card php-card">
              <FaPhp size={50} className="text-primary mx-auto mb-3" />
              <h5>PHP & Laravel</h5>
              <p>Building secure systems with expressive elegance.</p>
            </div>
          </div>
        </div>
      </div>
       <img className='background-image-right' src={colorSharp2} alt='Image' />
    </section>
  );
}
